import { FaReact, FaAngular, FaJs } from "react-icons/fa";
import { SiNextdotjs, SiNodedotjs } from "react-icons/si";

import article from "../Assets/article.jpg";
import citizenp from "../Assets/citizenp.png";
import clerk from "../Assets/clerk.png";
import dslms from "../Assets/dslms.png";
import facility from "../Assets/facility.png";
import mipad from "../Assets/mipad.png";
import polleasy from "../Assets/polleasy.png";
import proworks from "../Assets/proworks.png";
import stanbicupl from "../Assets/stanbicupl.png";
import mpi from "../Assets/mpi.png";

const projects = [
  {
    id: "2",
    nameKey: "Proj_LMS_Name",
    descKey: "Proj_LMS_Desc",
    icon: <FaReact style={{ fontSize: "100%" }} />,
    link: "http://dslms.ng/",
    pic: dslms,
    lang: "React/Next",
  },
  {
    id: "3",
    nameKey: "Proj_MIPAD_Name",
    descKey: "Proj_MIPAD_Desc",
    icon: <FaReact style={{ fontSize: "100%" }} />,
    link: "https://events.mipad.org",
    pic: mipad,
    lang: "React/Next",
  },
  {
    id: "4",
    nameKey: "Proj_Estate_Name",
    descKey: "Proj_Estate_Desc",
    icon: <FaReact style={{ fontSize: "100%" }} />,
    link: "https://demoestate.facilitybills.com/",
    pic: facility,
    lang: "React/Next",
  },
  {
    id: "5",
    nameKey: "Proj_Loan_Name",
    descKey: "Proj_Loan_Desc",
    icon: <FaAngular style={{ fontSize: "100%" }} />,
    link: "https://ezcash.stanbicibtc.com/",
    pic: stanbicupl,
    lang: "Angular",
  },
  {
    id: "6",
    nameKey: "Proj_Citizen_Name",
    descKey: "Proj_Citizen_Desc",
    icon: <FaReact style={{ fontSize: "100%" }} />,
    link: "https://oyo-citizen-dev.netlify.app/",
    pic: citizenp,
    lang: "React/Next",
  },
  {
    id: "7",
    nameKey: "Proj_RMS_Name",
    descKey: "Proj_RMS_Desc",
    icon: <FaReact style={{ fontSize: "100%" }} />,
    link: "https://starsightenergy.com/insights/",
    pic: article,
    lang: "React/Next",
  },
  {
    id: "8",
    nameKey: "Proj_Proworks_Name",
    descKey: "Proj_Proworks_Desc",
    icon: <FaReact style={{ fontSize: "100%" }} />,
    link: "https://proworks-oyo.vercel.app/",
    pic: proworks,
    lang: "React/Next",
  },
  {
    id: "9",
    nameKey: "Proj_PollEasy_Name",
    descKey: "Proj_PollEasy_Desc",
    icon: <FaReact style={{ fontSize: "100%" }} />,
    link: "https://lagos.polleasy.co/",
    pic: polleasy,
    lang: "React/Next",
  },
  {
    id: "10",
    nameKey: "Proj_Tech11_Name",
    descKey: "Proj_Tech11_Desc",
    icon: <FaJs style={{ fontSize: "100%" }} />,
    link: "https://dev-03.tech11.com/clerk-ui/",
    pic: clerk,
    lang: "Web Component",
  },
  {
    id: "12",
    nameKey: "Proj_NPI_Name",
    descKey: "Proj_NPI_Desc",
    icon: <SiNextdotjs style={{ fontSize: "100%" }} />,
    link: "https://www.nigeriapovertymap.com/",
    pic: mpi,
    lang: "React/Next",
  },
  {
    id: "13",
    nameKey: "Proj_HRMS_Name",
    descKey: "Proj_HRMS_Desc",
    icon: <SiNodedotjs style={{ fontSize: "100%" }} />,
    link: "",
    pic: "",
    lang: "Node",
  },

  {
    id: "14",
    nameKey: "Proj_LMS_BE_Name",
    descKey: "Proj_LMS_BE_Desc",
    icon: <SiNodedotjs style={{ fontSize: "100%" }} />,
    link: "",
    pic: "",
    lang: "Node",
  },

  {
    id: "15",
    nameKey: "Proj_Ecom_BE_Name",
    descKey: "Proj_Ecom_BE_Desc",
    icon: <SiNodedotjs style={{ fontSize: "100%" }} />,
    link: "",
    pic: "",
    lang: "Node",
  },
];

export default projects;
